import {
    FETCH_SUPPLIER_INCOME_REQUEST,
    FETCH_SUPPLIER_INCOME_SUCCESS,
    FETCH_SUPPLIER_INCOME_FAILURE,
  } from "./FetchSuppliesIncomeTypes";
  import api from "../../utils/Api";
  
  export const fetchSupplierIncomeRequest = () => {
    return {
      type: FETCH_SUPPLIER_INCOME_REQUEST,
    };
  };
  
  export const fetchSupplierIncomeSuccess = (supplierIncome) => {
    return {
      type: FETCH_SUPPLIER_INCOME_SUCCESS,
      payload: supplierIncome,
    };
  };
  
  export const fetchSupplierIncomeFailure = (error) => {
    return {
      type: FETCH_SUPPLIER_INCOME_FAILURE,
      payload: error,
    };
  };
  
  export const fetchSupplierIncome = (sortBy, page, payload) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "/report/supplies/fetch?sort_by="+sortBy + "&page="+ page;

    if(payload && payload.dateFrom){
        url += "&created_at=gte:"+ payload.dateFrom;
    }
    if(payload && payload.dateTo){
        url += "&created_at=lte:"+ payload.dateTo;
    }
    
    return async (dispatch) => {
      dispatch(fetchSupplierIncomeRequest());
      try {
        const response = await api.get(url,
          {
            headers: headers,
          }
        );
        const supplierIncome = response.data.data;
        //console.log("****** patient Income response", supplierIncome);
        dispatch(fetchSupplierIncomeSuccess(supplierIncome));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchSupplierIncomeFailure(errorMsg));
      }
    };
  };
  